import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
const generateWebpPath = (src) => {
    return src.replace(/\.(png|jpg|jpeg)$/i, '.webp');
};
const useBestImageSource = (src, webpSrc, autoWebp) => {
    const [bestSrc, setBestSrc] = useState(() => webpSrc ?? src);
    useEffect(() => {
        if (webpSrc) {
            setBestSrc(webpSrc);
            return;
        }
        setBestSrc(src);
        if (!autoWebp || !/\.(png|jpg|jpeg)$/i.test(src)) {
            return;
        }
        const webpPath = generateWebpPath(src);
        const img = new Image();
        img.onload = () => {
            setBestSrc(webpPath);
        };
        img.onerror = () => {
            setBestSrc(src);
        };
        img.src = webpPath;
    }, [src, webpSrc, autoWebp]);
    return bestSrc;
};
export const OptimizedImage = ({ src, webpSrc, alt, className, loading = 'lazy', sizes, width, height, autoWebp = true, 'data-testid': dataTestId, }) => {
    const bestSrc = useBestImageSource(src, webpSrc, autoWebp);
    return (_jsx("img", { src: bestSrc, alt: alt, className: className, loading: loading, width: width, height: height, sizes: sizes, "data-testid": dataTestId }));
};
